__turbopack_context__.v({
  "sourceOrigin": "ArticleModuleSourceOrigin-module-scss-module__7ARJoa__sourceOrigin",
});
